module.exports = __webpack_public_path__ + "img/img6.226fbd0f.svg";